import { UserRole, Users } from '@etoh/database/core';

export type UserRoleApp = UserRole | 'admin' | 'manager';

const userRoles: UserRole[] = ['guest', 'user'];

export function hasUserRole(user: Users, userRole: UserRoleApp): boolean {
  // Role from the database
  if (userRoles.includes(userRole as any)) {
    return user.role === userRole;
  }

  // Role from the app
  if (userRole === 'admin') {
    return user.isAdmin;
  }

  if (userRole === 'manager') {
    return user.isManager;
  }

  return false;
}
